import { render, staticRenderFns } from "./settingCompanyMainSettings.vue?vue&type=template&id=57c26110&scoped=true&"
import script from "./settingCompanyMainSettings.vue?vue&type=script&lang=js&"
export * from "./settingCompanyMainSettings.vue?vue&type=script&lang=js&"
import style0 from "./settingCompanyMainSettings.vue?vue&type=style&index=0&id=57c26110&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c26110",
  null
  
)

export default component.exports